<template>
  <div class="container">

    <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class=" col-12 col-lg-10 g-0 p-0 m-0 px-5 m-auto" data-aos="fade-in" data-aos-delay="200" data-aos-duration="1000" data-aos-id="start-counter-pacientes">
        <h2>{{ $t('contribucion.title') }}</h2>
        <h6 class="text-black my-3"><strong>{{ $t('contribucion.comportamiento') }}</strong></h6>
      </div>
      <table class="mt-5" cellpadding="0" cellspacing="0" width="100%">
        <tbody>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS01.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.condiciones') }}</li>
              <li class="text-black">{{ $t('contribucion.audas') }}</li>
              <li class="text-black">{{ $t('contribucion.participacion') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS02.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.desarrollo') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS03.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.contribucion') }}</li>
              <li class="text-black">{{ $t('contribucion.sostenimiento') }}</li>
              <li class="text-black">{{ $t('contribucion.centros') }}</li>
              <li class="text-black">{{ $t('contribucion.nivel') }}</li>
              <li class="text-black">{{ $t('contribucion.acciones') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS04.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.planes') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS05.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.compromiso') }}</li>
              <li class="text-black">{{ $t('contribucion.puestos') }}</li>
              <li class="text-black">{{ $t('contribucion.procedimiento') }}</li>
              <li class="text-black">{{ $t('contribucion.adhesion') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS06.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black" v-html="$t('contribucion.consumo_agua')"></li>
              <li class="text-black" v-html="$t('contribucion.implantacion')"></li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS07.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black" v-html="$t('contribucion.conusmo_energetico')"></li>
              <li class="text-black">{{ $t('contribucion.implantacion_2') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS08.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.mejora') }}</li>
              <li class="text-black">{{ $t('contribucion.se_han') }}</li>
              <li class="text-black">{{ $t('contribucion.programa') }}</li>
              <li class="text-black">{{ $t('contribucion.a_nivel_interno') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS09.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.soluciones_inovadoras') }}</li>
              <li class="text-black">{{ $t('contribucion.plan_transformacion') }}</li>
              <li class="text-black">{{ $t('contribucion.premios') }}</li>
              <li class="text-black">{{ $t('contribucion.investigacion') }}</li>
              <li class="text-black">{{ $t('contribucion.nueva_edicion') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS10.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.declaracion') }}</li>
              <li class="text-black">{{ $t('contribucion.charter') }}</li>
              <li class="text-black">{{ $t('contribucion.sello') }}</li>
              <li class="text-black">{{ $t('contribucion.plan_diversidad') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS11.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.criterios') }}</li>
              <li class="text-black">{{ $t('contribucion.nuevos_centros') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS12.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.politica_integrada') }}</li>
              <li class="text-black">{{ $t('contribucion.guia_contratacion') }}</li>
              <li class="text-black">{{ $t('contribucion.procedimiento_2') }}</li>
              <li class="text-black">{{ $t('contribucion.donaciones') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS13.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.huella') }}</li>
              <li class="text-black">{{ $t('contribucion.impacto_medioambienta') }}</li>
              <li class="text-black">{{ $t('contribucion.campanas') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS14.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
            <img :src="`${publicPath}img/${locale}ODS15.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.sistema_de_gestion') }}</li>
              <li class="text-black">{{ $t('contribucion.difusion') }}</li>
              <li class="text-black">{{ $t('contribucion.uso_eficiente') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS16.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.codigo') }}</li>
              <li class="text-black">{{ $t('contribucion.dotacion') }}</li>
              <li class="text-black">{{ $t('contribucion.delitos') }}</li>
              <li class="text-black">{{ $t('contribucion.proteccion_datos') }}</li>
              <li class="text-black">{{ $t('contribucion.control') }}</li>
              <li class="text-black">{{ $t('contribucion.responsabilidad') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="align-middle p-0 p-lg-2" width="130">
            <img :src="`${publicPath}img/${locale}ODS17.png`" data-aos="fade-left" data-aos-duration="1000" width="100" height="100">
          </td>
          <td class="align-middle text-start border-top border-bottom border-light">
            <ul class="my-3">
              <li class="text-black">{{ $t('contribucion.compormiso') }}</li>
              <li class="text-black">{{ $t('contribucion.firmantes') }}</li>
              <li class="text-black">{{ $t('contribucion.firma') }}</li>
              <li class="text-black">{{ $t('contribucion.adecuacion') }}</li>
            </ul>
          </td>
        </tr>
        </tbody>
      </table>
    </section>

    <!-- NAVEGACIÓ PRE-FOOTER -->
    <hr>
    <div class="row p-0 g-0 mb-3">
      <div class="col-6 p-0 m-0 pb-3 text-start">
        <localized-link class="footerLink" to="/sostenibilidad/plan-de-rsc-y-sostenibilidad-21-24"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.plan-de-rsc-y-sostenibilidad-21-24") }}</localized-link>
      </div>
      <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
        <localized-link class="footerLink" to="/sostenibilidad/impacto-en-el-entorno"> {{ $t("nav.impacto-entorno") }} <img :src="`${publicPath}img/arrowRight.png`" class="img-responsive arrowsFooter"></localized-link>
      </div>
    </div>

  </div>

</template>

<script>
  export default {
    data() {
      return {
        publicPath: process.env.BASE_URL,
        locale:this.$i18n.locale,
      }
    }
  }
</script>
